import { QueryHookOptions } from "@apollo/client"

import { useAuth } from "shared/lib/useAuth"
import { useRedux } from "shared/lib/useRedux"
import { Project } from "shared/types/Project"

import {
  ProjectsQuery,
  ProjectsQueryVariables,
  useProjectsQuery
} from "entities/projects/graphql/queries.generated"

const emptyProjects: Project[] = []

export function useProjects(
  options?: QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>
) {
  const { isAuthenticated, isLoading: isLoadingUser } = useAuth()
  const { data, loading, ...rest } = useProjectsQuery({
    ...options,
    skip: isLoadingUser || !isAuthenticated
  })

  const { pendingProjectIDs } = useRedux(({ projects }) => ({
    pendingProjectIDs: Object.entries(projects).reduce(
      (acc, [key, value]) => (value.isPending ? [...acc, key] : acc),
      [] as string[]
    )
  }))

  return {
    projects: data?.projects ?? emptyProjects,
    pendingProjectIDs,
    loading: isLoadingUser || loading,
    ...rest
  }
}
